// Shared helpers for the crawlable content pages (guides, guides hub, about,
// contact). backend/app.py renders the same markup server-side from the same
// JSON files, so any change here needs the matching change there.
import guideContent from '../public/content/guides.json';
import { formatDate } from './i18n/locales';

export function contentLabels(locale) {
  return guideContent.labels[locale];
}

// Last edit of a guide in one language: the later of the guide's "modified"
// (edits to every language) and that language's own (edits to it alone).
// Same as _guide_modified() in backend/app.py.
export function guideModified(guide, locale) {
  const dates = [guide.modified, guide[locale] && guide[locale].modified].filter(Boolean);
  return dates.sort().pop();
}

// "Published 27 September 2026 · Updated 3 October 2026" (updated only when it differs)
export function guideDates(guide, locale) {
  const labels = contentLabels(locale);
  const modified = guideModified(guide, locale);
  const parts = [`${labels.published} ${formatDate(guide.published, locale)}`];
  if (modified && modified !== guide.published) {
    parts.push(`${labels.updated} ${formatDate(modified, locale)}`);
  }
  return parts.join(' · ');
}
